import { render, staticRenderFns } from "./BarChartX.vue?vue&type=template&id=20f6f119&scoped=true&"
import script from "./BarChartX.vue?vue&type=script&lang=js&"
export * from "./BarChartX.vue?vue&type=script&lang=js&"
import style0 from "./BarChartX.vue?vue&type=style&index=0&id=20f6f119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6f119",
  null
  
)

export default component.exports